export default __webpack_public_path__ + "static/media/hht2_storybook_12.490a8894.png";